import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactResponseModel } from '../model/contact-response.model';

@Injectable()
export class ContactService {
  private readonly url = "https://api.1artifactware.com/email/send";
  constructor(private httpClient: HttpClient) { }

  sendEmail(name: string, email: string, message: string, captcha: string): Observable<ContactResponseModel> {
    return this.httpClient.post<ContactResponseModel>(this.url, { name, email, message, captcha }, { responseType: 'json' });
  }
}
